document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const originalHTML = btn.innerHTML;
  const addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

  btn.disabled = true;

  fetch(addUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((res) => {
      if (!res.ok) return res.json().then((err) => Promise.reject(err));
      return res.json();
    })
    .then(() => window.theme.cart.getCart())
    .then((cart) => {
      updateCartCount(cart.item_count);

      // Harmless now, but means this button will "just work" if cartType
      // is ever switched to 'drawer' in theme settings later.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      btn.classList.add('is-added');
      btn.innerHTML = 'Added ✓';
      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }, 1200);
    })
    .catch((err) => {
      console.error('Quick add failed:', err);
      btn.innerHTML = 'Try Again';
      btn.disabled = false;
      setTimeout(() => { btn.innerHTML = originalHTML; }, 1500);
    });
});

function updateCartCount(count) {
  document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
    el.innerText = count;
  });

  document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
    bubble.classList.toggle('cart-link__bubble--visible', count > 0);
  });
}